import React from 'react';

const TermsConditions: React.FC = () => {
    return (
        <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
                <div className="bg-white shadow-lg rounded-lg p-8">
                    <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
                        Terms and Conditions
                    </h1>
                    
                    <div className="text-center py-16">
                        <div className="text-6xl mb-4">🔒</div>
                        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
                            Terms and Conditions Coming Soon
                        </h2>
                        <p className="text-gray-500 text-lg max-w-md mx-auto">
                            We're working on creating a comprehensive terms and conditions document to protect your data. 
                            This feature will be available soon.
                        </p>
                        
                    </div>
                    
                    <div className="border-t pt-8 mt-8 text-center text-sm text-gray-500">
                        <p>For any Terms and Conditions related questions, please contact us at HR@gentari.co.in</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsConditions;